import store from "../projectConfig/interConfig/rhqy/store";
/**
 * 权限控制指令 v-permission
 * 使用方式：
 * <button v-permission="'add'">添加</button>
 * <button v-permission="['edit', 'delete']">编辑/删除</button>
 */
const checkPermission = (value) => {
  if (!value) return false
  
  // 这里获取当前用户的权限列表，实际项目中可能从Vuex或本地存储获取
  const permissions = store.state.privilegeConfig.keys || [];
  
  if (Array.isArray(value)) {
    return value.some(permission => permissions.includes(permission))
  }
  
  return permissions.includes(value)
}

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const hasPermission = checkPermission(value)
    
    if (!hasPermission) {
      // 如果没有权限，移除DOM元素
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}